<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Ano Letivo"
              v-model="form.filters.ano"
              outlined
              dense
              maxlength="4"
              hide-details
              v-only-number
              @keyup.enter="buscarAnosLetivos"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Duração (semanas)"
              v-model="form.filters.duracao"
              outlined
              maxlength="3"
              dense
              hide-details
              v-only-number
              @keyup.enter="buscarAnosLetivos"
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
          ></sca-select-ativo>
        </v-row>
        <v-row class="d-flex justify-center mt-0">
          <sca-date-picker
            :cols="3"
            label="Data de Início"
            v-model="form.filters.dataInicio"
            outlined
            dense
            :allowedDates="anoAtualOuMaior"
            :rules="[dataInicioMenorQueFim]"
          ></sca-date-picker>
          <sca-date-picker
            :cols="3"
            label="Data de Término"
            v-model="form.filters.dataFim"
            outlined
            dense
            :allowedDates="anoAtualOuMaior"
            :rules="[dataInicioMenorQueFim]"
          ></sca-date-picker>
          <v-col cols="3"></v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarAnosLetivos()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterAnoLetivo()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="noDataText"
      >
        <template v-slot:[`item.dataInicio`]="{ item }">
          <span>{{ item.dataInicio | date }}</span>
        </template>
        <template v-slot:[`item.dataFim`]="{ item }">
          <span>{{ item.dataFim | date }}</span>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarAnoLetivo(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterAnoLetivo(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarAnoLetivo(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarAnoLetivoDialog
      :visible="dialogManterAnoLetivo.visible"
      :content="dialogManterAnoLetivo.content"
      :edit="dialogManterAnoLetivo.edit"
      @onClose="dialogManterAnoLetivo.close()"
      @onSave="buscarAnosLetivos()"
    ></CadastrarEditarAnoLetivoDialog>
    <VisualizarAnoLetivoDialog
      v-if="dialogVisualizarAnoLetivo.visible"
      :visible="dialogVisualizarAnoLetivo.visible"
      :content="dialogVisualizarAnoLetivo.content"
      @onClose="dialogVisualizarAnoLetivo.close()"
    ></VisualizarAnoLetivoDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { AnoLetivo } from '~/commons/classes/ano-letivo';
import AnoLetivoService from '~/services/ano-letivo.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarAnoLetivoDialog from "./dialogs/CadastrarEditarAnoLetivoDialog.vue";
import VisualizarAnoLetivoDialog from "./dialogs/VisualizarAnoLetivoDialog.vue";

export default {
  name: "ManterAnoLetivosView",
  mixins: [AnoLetivoService, datatablesMixin],
  components: {
    CadastrarEditarAnoLetivoDialog,
    VisualizarAnoLetivoDialog,
  },
  data: () => ({
    dialogManterAnoLetivo: Dialog.Build(),
    dialogVisualizarAnoLetivo: Dialog.Build(),
    form: {
      filters: {
        ano: null,
        ducarao: null,
        dataInicio: null,
        dataFim: null,
        ativo: null,
      },
      menu: {
        dataInicio: false,
        dataFim: false,
      },
      isLoading: false,
    },
    table: {
      headers: [
        { text: 'Ano Letivo', align: 'center', value: 'ano' },
        { text: 'Data de Início', align: 'center', value: 'dataInicio' },
        { text: 'Data de Término', align: 'center', value: 'dataFim' },
        { text: 'Duração (semanas)', align: 'center', value: 'duracaoEmSemanas' },
        { text: 'Situação', align: 'center', value: 'situacao', sortable: false },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
    },
  }),
  methods: {
    buscarAnosLetivos() {
      if(this.$validarFormulario()) {
        this.form.isLoading = true;
        this.$buscarAnosLetivos({ params: this.form.filters })
        .then(({ data }) => (this.table.itens = data.itens))
        .finally(() => this.form.isLoading = false);
      }
    },
    openDialogManterAnoLetivo(anoletivo) {
      anoletivo
        ? this.$visualizarAnoLetivos(anoletivo).then(
          ({ data }) => this.dialogManterAnoLetivo.open(new AnoLetivo(data.resposta), true))
        : this.dialogManterAnoLetivo.open(AnoLetivo.Build());
    },
    openDialogVisualizarAnoLetivo(anoletivo) {
      this.$visualizarAnoLetivos(anoletivo).then(
        ({ data }) => this.dialogVisualizarAnoLetivo.open(new AnoLetivo(data.resposta)));
    },
    inativarAtivarAnoLetivo(anoletivo) {
      this.$swal({
        text: `Deseja ${anoletivo.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarAnoLetivo(anoletivo.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarAnosLetivos();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.form.filters.ativo = null;
      this.form.filters.dataInicio = null;
      this.form.filters.dataFim = null;
    },
    dataInicioMenorQueFim() {
      const filters = this.form.filters
      if (filters.dataInicio && filters.dataFim) {
        return filters.dataInicio < filters.dataFim || "A data de término deve ser após a data de início";
      }
      return true;
    },
    anoAtualOuMaior(date) {
      return parseInt(date.split('-')[0]) >= (new Date().getFullYear())
    },
  },
  computed: {
    computedDataInicio() {
      const data = this.form.filters.dataInicio
      if (data) {
        const [year, month, day] = data.split('-');
        return data ? `${day}/${month}/${year}` : '';
      }
      return '';
    },
  }
};
</script>
